var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    [
      _c("li", [
        _c("h3", [_vm._v(_vm._s(_vm.t("health", "Column selection", {})))])
      ]),
      _vm._v(" "),
      _c(
        "ActionCheckbox",
        {
          attrs: { checked: _vm.person.measurementColumnTemperature },
          on: {
            change: function($event) {
              return _vm.$store.dispatch("setValue", {
                key: "measurementColumnTemperature",
                value: $event.target.checked
              })
            }
          }
        },
        [_vm._v("\n\t\t" + _vm._s(_vm.t("health", "Temperature", {})) + "\n\t")]
      ),
      _vm._v(" "),
      _c(
        "ActionCheckbox",
        {
          attrs: { checked: _vm.person.measurementColumnHeartRate },
          on: {
            change: function($event) {
              return _vm.$store.dispatch("setValue", {
                key: "measurementColumnHeartRate",
                value: $event.target.checked
              })
            }
          }
        },
        [_vm._v("\n\t\t" + _vm._s(_vm.t("health", "Heart rate", {})) + "\n\t")]
      ),
      _vm._v(" "),
      _c(
        "ActionCheckbox",
        {
          attrs: { checked: _vm.person.measurementColumnBloodPres },
          on: {
            change: function($event) {
              return _vm.$store.dispatch("setValue", {
                key: "measurementColumnBloodPres",
                value: $event.target.checked
              })
            }
          }
        },
        [_vm._v("\n\t\t" + _vm._s(_vm.t("health", "Blood pressure")) + "\n\t")]
      ),
      _vm._v(" "),
      _c(
        "ActionCheckbox",
        {
          attrs: { checked: _vm.person.measurementColumnOxygenSat },
          on: {
            change: function($event) {
              return _vm.$store.dispatch("setValue", {
                key: "measurementColumnOxygenSat",
                value: $event.target.checked
              })
            }
          }
        },
        [
          _vm._v(
            "\n\t\t" + _vm._s(_vm.t("health", "Oxygen saturation", {})) + "\n\t"
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "ActionCheckbox",
        {
          attrs: { checked: _vm.person.measurementColumnBloodSugar },
          on: {
            change: function($event) {
              return _vm.$store.dispatch("setValue", {
                key: "measurementColumnBloodSugar",
                value: $event.target.checked
              })
            }
          }
        },
        [_vm._v("\n\t\t" + _vm._s(_vm.t("health", "Blood sugar", {})) + "\n\t")]
      ),
      _vm._v(" "),
      _c(
        "ActionCheckbox",
        {
          attrs: { checked: _vm.person.measurementColumnAppetite },
          on: {
            change: function($event) {
              return _vm.$store.dispatch("setValue", {
                key: "measurementColumnAppetite",
                value: $event.target.checked
              })
            }
          }
        },
        [_vm._v("\n\t\t" + _vm._s(_vm.t("health", "Appetite", {})) + "\n\t")]
      ),
      _vm._v(" "),
      _c(
        "ActionCheckbox",
        {
          attrs: { checked: _vm.person.measurementColumnAllergies },
          on: {
            change: function($event) {
              return _vm.$store.dispatch("setValue", {
                key: "measurementColumnAllergies",
                value: $event.target.checked
              })
            }
          }
        },
        [_vm._v("\n\t\t" + _vm._s(_vm.t("health", "Allergies", {})) + "\n\t")]
      ),
      _vm._v(" "),
      _c(
        "ActionCheckbox",
        {
          attrs: { checked: _vm.person.measurementColumnDefecation },
          on: {
            change: function($event) {
              return _vm.$store.dispatch("setValue", {
                key: "measurementColumnDefecation",
                value: $event.target.checked
              })
            }
          }
        },
        [_vm._v("\n\t\t" + _vm._s(_vm.t("health", "Defecation", {})) + "\n\t")]
      ),
      _vm._v(" "),
      _c("li", [
        _c("h3", [_vm._v(_vm._s(_vm.t("health", "General settings", {})))])
      ]),
      _vm._v(" "),
      _c(
        "ActionCheckbox",
        {
          attrs: { checked: _vm.person.measurementChartDetail },
          on: {
            change: function($event) {
              return _vm.$store.dispatch("setValue", {
                key: "measurementChartDetail",
                value: $event.target.checked
              })
            }
          }
        },
        [
          _vm._v(
            "\n\t\t" +
              _vm._s(_vm.t("health", "Show time detail chart", {})) +
              "\n\t"
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }